export enum NoteRule {
    INTAKE_NOTE = "intake_note",
    SAME_DAY_NOTE = "same_day_note",
}

export enum NoteRuleBypassStatus {
    ACTIVE = "active",
    DISABLED = "disabled",
}

export const RULE_LABELS: Record<NoteRule, string> = {
    [NoteRule.INTAKE_NOTE]: "Intake rule",
    [NoteRule.SAME_DAY_NOTE]: "Same day rule",
};

export interface INoteRuleBypassFilters {
    rule?: NoteRule;
    provider_name?: string;
    client_name?: string;
    status?: NoteRuleBypassStatus;
    from_date?: string | null;
    to_date?: string | null;
    sort_by?: string;
    sort_direction?: string;
    page?: number;
    limit?: number;
}

export interface INoteRuleBypass {
    bypass_id: string;
    practice_id: string;
    provider_id: string;
    client_id: string;
    rule: NoteRule;
    status: NoteRuleBypassStatus;
    created_by: string;
    created_at: string;
    updated_by: string | null;
    updated_at: string;
}

export interface INoteRuleBypassListRow
    extends Omit<INoteRuleBypass, "practice_id" | "created_by" | "updated_by"> {
    provider_name: string;
    client_name: string;
    created_by: {
        user_id: string;
        first_name: string;
        last_name: string;
    };
}

export interface ICreateNoteRuleBypassPayload {
    rule: NoteRule;
    provider_id: string;
    client_id: string;
}

export interface IUpdateNoteRuleBypassStatusPayload {
    bypass_id: string;
    status: NoteRuleBypassStatus;
}

export interface INoteRuleBypassClient {
    client_id: string;
    client_name: string;
    first_name: string;
    last_name: string;
    last_session_date: string | null;
    session_count: number;
}

export interface IProviderClientsForBypass {
    clients: INoteRuleBypassClient[];
}

export interface IProviderClientsForBypassFilters {
    provider_id: string;
    rule: NoteRule;
    search?: string;
    limit?: number;
}
